module.exports = __webpack_public_path__ + "static/media/arrow_right_noline.a534a0a7.svg";